import { configuration } from 'src/configuration';
import { store } from 'src/store';
import { selectAuthToken } from 'src/store/selectors';
import { get } from 'src/utils/fetch';
import { to } from 'to-await';

export async function semanticSearchAurora(
  tableName: string,
  query: string,
  numResults = 100,
): Promise<any[]> {
  const state = store.getState();
  const idToken = selectAuthToken(state);
  const organizationId = state.createCohort.rootOrganizationId || '';
  const url = `${configuration.appApiUrl}/data-sources/search-query-aurora?tableName=${tableName}&query=${query}&numResults=${numResults}`;

  const [error, response] = await to(
    get(url, {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json',
        'X-Medeloop-Context-Organization': organizationId,
      },
    }),
  );

  if (error) {
    throw new Error(error.message);
  }

  return response?.body?.results || [];
}
